import { createStore, createHook } from "react-sweet-state";
import { removeScheduleApi } from "../api";

const Store = createStore({
  // value of the store on initialisation
  initialState: {
    loading: true,
  },
  // actions that trigger store mutation
  actions: {
    deleteData:
      ({ personId, date }, onSuccess) =>
      async ({ setState, getState }) => {
        setState({ isLoading: true });

        try {
          const resp = await removeScheduleApi({personId, date});

          if (resp.data && resp.data.code === 200) {
            setState({
              isLoading: false,
            });
            if (onSuccess) {
              onSuccess();
            }
            return;
          }
        } catch (err) {
          setState({
            error: err && err.response ? err.response.data : "Unknown error",
          });
        }

        setState({ isLoading: false });
      },
  },
  // optional, mostly used for easy debugging
  name: "deleteScheduleService",
});

export const useDeleteScheduleStore = createHook(Store);
